import React, { useState } from 'react'
import { Draft, editDraft, sendDraft } from '../lib/api'

interface Props {
  draft: Draft
  onSent?: (draftId: number) => void
}

export default function DraftEditor({ draft, onSent }: Props) {
  const [body, setBody] = useState(draft.edited_body ?? draft.body)
  const [subject, setSubject] = useState(draft.subject)
  const [saving, setSaving] = useState(false)
  const [sent, setSent] = useState(draft.status === 'approved' || draft.status === 'sent')
  const [error, setError] = useState<string | null>(null)

  async function handleSend() {
    setSaving(true)
    setError(null)
    try {
      // Save edits first if body changed
      if (body !== draft.body || subject !== draft.subject) {
        await editDraft(draft.id, body, subject !== draft.subject ? subject : undefined)
      }
      await sendDraft(draft.id)
      setSent(true)
      onSent?.(draft.id)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Send failed')
    } finally {
      setSaving(false)
    }
  }

  if (sent) {
    return (
      <div className="draft-editor sent">
        <div className="draft-sent-label">✓ Approved</div>
        <div className="draft-to">To: {draft.to_name || draft.to_email}</div>
        <div className="draft-subject">{subject}</div>
      </div>
    )
  }

  return (
    <div className="draft-editor">
      <div className="draft-header">
        <span className="draft-label">Draft</span>
        <span className="draft-to">To: {draft.to_name || draft.to_email} &lt;{draft.to_email}&gt;</span>
      </div>
      <input
        className="draft-subject-input"
        value={subject}
        onChange={e => setSubject(e.target.value)}
        disabled={saving}
      />
      <textarea
        className="draft-body-input"
        value={body}
        onChange={e => setBody(e.target.value)}
        rows={6}
        disabled={saving}
      />
      {error && <div className="draft-error">{error}</div>}
      <div className="draft-actions">
        <button className="chat-btn primary" onClick={handleSend} disabled={saving}>
          {saving ? 'Saving...' : 'Approve & Send'}
        </button>
      </div>
    </div>
  )
}
